import { FaFolderOpen } from "react-icons/fa";
import Selector from "../components/ui/components/Selector";
import { Limits10_50 } from "../utils/plainValues/DefaultLimits";
import SearchBar from "../components/ui/components/SearchBar";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { BACKEND } from "../config/configEnvs";
import axios from "axios";
import { toast } from "react-toastify";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import ItemRowVentasComercial from "../components/ventasComercial/ItemRowVentasComercial";
import ItemRowVentasOperativa from "../components/ventasComercial/itemRowVentasOperativa";
import ItemRowVentasAudiovisuales from "../components/ventasComercial/ItemRowVentasAudiovisuales";
import PaginationItem from "../components/ui/components/Pagination";
import CheckBoxLabel from "../components/ui/components/CheckBoxLabel";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

const IntegracionProyectos = () => {

  const user = useSelector((state) => state.auth.user)

  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)

  const [searchValue, setSearchValue] = useState("")
  const [loading, setLoading] = useState(false)

  const [totalDocs, setTotalDocs] = useState(0)
  const [totalPages, setTotalPages] = useState(0)

  const [record, setRecord] = useState([])
  const [workers, setWorkers] = useState([])
  const [solutions, setSolutions] = useState([])

  const [view, setView] = useState("Ventas") // Ventas | Operativa | Audiovisuales

  const [onlyAudiovisual, setOnlyAudiovisual] = useState(true)
  const [activeAgency, setActiveAgency] = useState(false)

  const colorAudiovisual = {    
    "No definido": "text-black",
    "Por comenzar": "text-yellow-300",
    "En proceso": "text-blue-500",
    "Terminado con exito": "text-green-500",
    "No finalizado": "text-red-500",
    "Congelado": "text-sky-500",
    "Abandonado": "text-black"
  }

  // Permisos de visualización para la vista (basados en config-navigation)
  const userArea = user?.area?.toUpperCase()
  const userSubarea = user?.subarea?.toUpperCase()

  const viewOptions = useMemo(() => {
    const canViewVentas = userArea === "ADMINISTRACION" || userArea === "COMERCIAL"
    const canViewOperativa = userArea === "ADMINISTRACION" || userArea === "SOFTWARE" || userArea === "MARKETING"
    const canViewAudiovisuales = (
      userArea === "ADMINISTRACION" ||
      (userArea === "MARKETING" && (userSubarea === "AUDIOVISUALES" || userSubarea === "SOCIAL MEDIA"))
    )

    const options = []
    if (canViewVentas) options.push({ label: "Ventas", value: "Ventas" })
    if (canViewOperativa) options.push({ label: "Operativa", value: "Operativa" })
    if (canViewAudiovisuales) options.push({ label: "Audiovisuales", value: "Audiovisuales" })
    return options
  }, [userArea, userSubarea])

  // Asegurar que la vista seleccionada sea permitida; si no, seleccionar la primera permitida
  useEffect(() => {
    if (!viewOptions.find((o) => o.value === view) && viewOptions.length > 0) {
      setView(viewOptions[0].value)
    }
  }, [viewOptions, view])

  useEffect(() => { // Solo se ejecuta cuando se vacea la barra de búsqueda
    if (searchValue === "") {
      if (view === "Ventas") {
        getSalesRecord(); // Solo se ejecuta cuando se reinicia la búsqueda
      } else if (view === "Operativa") {
        getOperativeRecord(); // Solo se ejecuta cuando se reinicia la búsqueda
      } else if (view === "Audiovisuales") {
        getAudiovisualRecord(); // Solo se ejecuta cuando se reinicia la búsqueda
      }
      setPage(1); // Reiniciar la paginación si es necesario
    }
  }, [searchValue]);

  const getWorkers = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/getUsersIds/getWorkerUsers`)
      setWorkers(response.data)
    } catch (error) {
      console.log(error)
    }
  }

  const getSolutions = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/servicios?limit=0`)
      setSolutions(response.data.docs)
    } catch (error) {
      console.log(error)
    }
  }

  const getOperativeRecord = async () => {
    try {
      setLoading(true)
      let url = `${BACKEND}/api/serviciosCotizaciones?where[cotizacion.estado][equals]=Exito&page=${page}&limit=${limit}&where[servicio.categoria][not_equals]=Hosting y dominio&where[produccionAudiovisual][equals]=true`
      
      if (searchValue) {
        url += `&where[cotizacion.cliente.nombreComercial][like]=${searchValue}`
      }
      const response = await axios.get(url)
      
      setRecord(response.data.docs)
      setTotalPages(response.data.totalPages)
      setTotalDocs(response.data.totalDocs)
    } catch (error) {
      console.log(error)
      toast.error("Error al obtener los registros de operativa: " + error)
    } finally {
      setLoading(false)
    }
  }

  const getSalesRecord = async () => {
    try {
      setLoading(true)
      let url = `${BACKEND}/api/serviciosCotizaciones?where[cotizacion.estado][equals]=Exito&page=${page}&limit=${limit}&where[servicio.categoria][not_equals]=Hosting y dominio`
      
      if (searchValue) {
        url += `&where[cotizacion.cliente.nombreComercial][like]=${searchValue}`
      }

      if (onlyAudiovisual) {
        url += `&where[produccionAudiovisual][equals]=true`
      } else {
        url += `&where[produccionAudiovisual][not_equals]=true`
      }

      const response = await axios.get(url)

      setRecord(response.data.docs)
      setTotalPages(response.data.totalPages)
      setTotalDocs(response.data.totalDocs)
    } catch (error) {
      console.log(error)
      toast.error("Error al obtener los registros de ventas: " + error)
    } finally {
      setLoading(false)
    }
  }

  const getAudiovisualRecord = async () => {
    try {
      setLoading(true)
      let url = `${BACKEND}/api/serviciosCotizaciones?where[cotizacion.estado][equals]=Exito&page=${page}&limit=${limit}&where[servicio.categoria][not_equals]=Hosting y dominio&where[produccionAudiovisual][equals]=true`

      if (searchValue) {
        url += `&where[cotizacion.cliente.nombreComercial][like]=${searchValue}`
      }

      const response = await axios.get(url)
      
      setRecord(response.data.docs)
      setTotalPages(response.data.totalPages)
      setTotalDocs(response.data.totalDocs)

    } catch (error) {
      console.log(error)
      toast.error("Error al obtener los registros audiovisuales: " + error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getWorkers()
    getSolutions()
  }, [])

  useEffect(() => {
    if (view === "Ventas") {
      getSalesRecord()
    } else if (view === "Operativa") {
      getOperativeRecord()
    } else if (view === "Audiovisuales") {
      getAudiovisualRecord()
    }
  }, [view])

  useEffect(() => {
    if (view === "Ventas") {
      getSalesRecord()
    }
  }, [onlyAudiovisual])

  const ventasHeaders = [
    { id: 1, show: true, name: "Cliente" },
    { id: 2, show: true, name: "Estado proyecto audiovisual" },
    { id: 3, show: true, name: "Servicio" },
    { id: 4, show: true, name: "Plan" },
    { id: 5, show: true, name: "Ingreso", info: "Fecha de cuando el cliente realizó el primer pago" },
    { id: 6, show: true, name: "Inicio", info: "Fecha de la primera reunión del área operativa con el cliente." },
    { id: 7, show: true, name: "Envío info.", info: "Fecha en la que el cliente terminó de enviar el 100% de la información." },
    { id: 8, show: true, name: "Fin", info: "Fecha establecida por administración para terminar el proyecto." },
    { id: 9, show: true, name: "Terminación", info: "Fecha de cuando se terminó la web, el cliente ya no tiene más cambios y se empieza el proceso de cobranza por parte de administración." },
    { id: 10, show: true, name: "Entrega", info: "Fecha de entrega de la web una vez el cliente pagó el 100%. Entrega de credenciales, video de capacitación, migracion al hosting del cliente (en caso sea necesario), etc. Servicio 100% completado." },
    { id: 11, show: true, name: "Vendedor" },
    { id: 12, show: true, name: "Testimonio del cliente en video" },
    { id: 13, show: true, name: "Revisión en Google Maps" },
    { id: 14, show: true, name: "Revisión en Facebook" },
    { id: 15, show: true, name: "Video subido a plataformas" },
    { id: 16, show: true, name: "Se le ofreció otros servicios" },  
    { id: 17, show: true, name: "Servicios interés" },
  ]

  const operativesHeaders = [
    { id: 1, show: true, name: "Cliente" },
    { id: 2, show: true, name: "Estado proyecto audiovisual" },
    { id: 3, show: true, name: "Servicio" },
    { id: 4, show: true, name: "Plan" },
    { id: 5, show: true, name: "Especialista a cargo" },
    { id: 6, show: true, name: "Vendedor" },
    { id: 7, show: true, name: "Ingreso", info: "Fecha de cuando el cliente realizó el primer pago" },
    { id: 8, show: true, name: "Inicio", info: "Fecha de la primera reunión del área operativa con el cliente." },
    { id: 9, show: true, name: "Envío info.", info: "Fecha en la que el cliente terminó de enviar el 100% de la información." },
    { id: 10, show: true, name: "Fin", info: "Fecha establecida por administración para terminar el proyecto." },
    { id: 11, show: true, name: "Terminación", info: "Fecha de cuando se terminó la web, el cliente ya no tiene más cambios y se empieza el proceso de cobranza por parte de administración." },
    { id: 12, show: true, name: "Entrega", info: "Fecha de entrega de la web una vez el cliente pagó el 100%. Entrega de credenciales, video de capacitación, migracion al hosting del cliente (en caso sea necesario), etc. Servicio 100% completado." },
    { id: 13, show: true, name: "Link proyecto grabado (especialista)" },
    { id: 14, show: true, name: "Link proyecto makingOf (especialista)" },
  ]

  const audiovisualesHeaders = [
    { id: 1, show: true, name: "Productor" },
    { id: 2, show: true, name: "Estado proyecto audiovisual" },
    { id: 3, show: true, name: "Cliente" },
    { id: 4, show: true, name: "Servicio" },
    { id: 5, show: true, name: "Plan" },
    { id: 6, show: true, name: "Ingreso", info: "Fecha de cuando el cliente realizó el primer pago" },
    { id: 7, show: true, name: "Inicio", info: "Fecha de la primera reunión del área operativa con el cliente." },
    { id: 8, show: true, name: "Envío info.", info: "Fecha en la que el cliente terminó de enviar el 100% de la información." },
    { id: 9, show: true, name: "Fin", info: "Fecha establecida por administración para terminar el proyecto." },
    { id: 10, show: true, name: "Terminación", info: "Fecha de cuando se terminó la web, el cliente ya no tiene más cambios y se empieza el proceso de cobranza por parte de administración." },
    { id: 11, show: true, name: "Entrega", info: "Fecha de entrega de la web una vez el cliente pagó el 100%. Entrega de credenciales, video de capacitación, migracion al hosting del cliente (en caso sea necesario), etc. Servicio 100% completado." },
    { id: 12, show: true, name: "Vendedor" },
    { id: 13, show: true, name: "Especialista a cargo de la grabación" },
    { id: 14, show: true, name: "Link testimonio cliente (video)" },
    { id: 15, show: true, name: "Links proyecto grabado (especialista)" },
    { id: 16, show: true, name: "Links proyecto makingOf (especialista)" },
    { id: 17, show: true, name: "Links testimonio cliente en video editado (audiovisuales)" },
    { id: 18, show: true, name: "Links proyecto editado (audiovisuales)" },
    { id: 19, show: true, name: "Links video making of editado (audiovisuales)" },
    { id: 20, show: true, name: "Video plataformas" },
  ]

  const views = [
    "Ventas",
    "Operativa",
    "Audiovisuales",
  ]

  return (
    <div className="flex flex-col h-screen w-full">

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between">
          
          <div className="flex items-center gap-4 py-4">
            <FaFolderOpen className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Integración Proyectos</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">
            {view === "Ventas" && (
              <CheckBoxLabel
                label="Mostrar solo proyectos que reqsuieren audiovisual"
                checked={onlyAudiovisual}
                setter={setOnlyAudiovisual}
              />
            )}
            <Selector 
              title="Límite"
              setter={setLimit}
              value={limit}
              width="w-[5rem]"
              options={Limits10_50}
            />
            <SearchBar
              value={searchValue}
              setter={setSearchValue}
              pageSetter={setPage}
              getter={view === "Ventas" ? getSalesRecord : view === "Operativa" ? getOperativeRecord : getAudiovisualRecord}
            />
          </div>

        </div>
      </div>

      {/* Filtros */}
      <div className="flex flex-row items-center bg-white justify-center bg-gray-100 mt-0.5 mb-0.5 gap-8">
        <div className="flex flex-row items-center justify-center gap-6">
          <CheckBoxLabel
            label="Activo agencia"
            checked={activeAgency}
            setter={setActiveAgency}
          />
          <ToggleButtonGroup
            color="primary"
            value={view}
            exclusive
            aria-label="Platform"
            onChange={(e, nv) => setView(nv)}
            sx={{ 
              borderRadius: "8px",
              width: "100%" 
            }} // Ancho completo
          >
            {
              views.map((v) => (
                <ToggleButton
                  value={v}
                  sx={{ 
                    fontSize: "12px",
                    fontWeight: "bold", 
                    whiteSpace: "nowrap",
                    padding: "4px 24px",
                    flex: 1,
                    fontFamily: "poppins",
                    textTransform: "none",
                  }}
                >
                  {v}
                </ToggleButton>
              ))
            }
          </ToggleButtonGroup>
        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loading ? (
          <LoadingScreen />
        ) : (
          record.length === 0 ? (
            <NoDataScreen />
          ) : (
            <table className="w-full text-xs">
              <thead className="text-xs sticky top-0 text-gray-900 bg-gray-200 z-20">
                <tr className="text-gray-700 text-center text-xs font-bold">
                  {(view === "Ventas" ? ventasHeaders : view === "Operativa" ? operativesHeaders : audiovisualesHeaders)
                    .filter((h) => h.show)
                    .map((h, idx) => {
                    return (
                      <td key={idx} className="px-4 py-3 text-xs text-center bg-[#FE6400] border-r border-r-white text-white border-red z-20">{h.name}</td>
                    )
                  })}
                </tr>
              </thead>
              <tbody>
                {record.map((s, i) => {
                  if (view === "Ventas") {
                    return (
                      <ItemRowVentasComercial
                        key={i}
                        s={s}
                        setServices={setRecord}
                        solutions={solutions}
                        user={user}
                      />
                    )
                  } else if (view === "Operativa") {
                    return (
                      <ItemRowVentasOperativa 
                        key={i}
                        s={s}
                        colorAudiovisual={colorAudiovisual}
                      />
                    )
                  } else {
                    return (
                      <ItemRowVentasAudiovisuales 
                        key={i}
                        s={s}
                        setServices={setRecord}
                        workers={workers}
                        user={user}
                        colorAudiovisual={colorAudiovisual}
                      />
                    )
                  }
                })}
              </tbody>
            </table>
          )
        )}
      </div>

      {/* Paginador */}
      <PaginationItem
        actualDocs={record.length}
        totalDocs={totalDocs}
        entity={"servicios"}
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={(e, v) => setPage(v)}
      />

    </div>
  )
}

export default IntegracionProyectos;